import { ActionTree } from 'vuex';

import { IInvoiceState } from '@/store/modules/invoice/types';
import { IRootState } from '@/store/types';

export const actions: ActionTree<IInvoiceState, IRootState> = {
};
